type GetJitterTime = (min: number, max: number) => number;
export const getJitterTime: GetJitterTime = (min, max) => Math.floor(Math.random() * (max - min)) + min;
